import React from 'react';
import PropTypes from 'prop-types';
import EmptyIcon from '@/svg-icons/empty';

const Empty = ({ header, subHeader }) => {
  return (
    <div className="h-full text-center">
      <div className="mx-[1vw] bg-[#EAEAEA] border-[#DEDEDE] border-2 min-h-[calc(100%-4px)] flex flex-col items-center">
        <div className="mt-[6vh] text-[calc(16px+0.4vw)] font-normal text-black/80">
          <span>{header}</span>
        </div>
        <div className="text-[calc(14px+0.4vw)] font-normal text-black/60">
          <span>{subHeader}</span>
        </div>
        <div className="mt-[10px] mb-[5vh]">
          <EmptyIcon
            viewBox="0 0 104 104"
            className="text-[calc(48px+0.8vw)] align-middle opacity-40"
          />
        </div>
      </div>
    </div>
  );
};

Empty.propTypes = {
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  subHeader: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};

export default Empty;
